import React from 'react';
import styled from 'styled-components';

import Title from 'components/Title';
import { Text } from 'components/Text';
import { EndOfRoundButtons } from 'components/Button';

import { processText } from 'core/utils/string';
import { web } from 'submodules/sharedText/flavor';

const { vampireWin } = web;
const flavor = { ...vampireWin };

const Wrapper = styled.div`
  text-align: center;
`;

const VampireWin = ({ player, ...resetMethods }) => {
  const { role, vip, expired } = player;
  const expiredKey = expired ? 'expired' : 'notExpired';
  return (
    <Wrapper>
      <Title>{processText(flavor.title[role])}</Title>
      <Text>{processText(flavor.content?.[role]?.[expiredKey])}</Text>
      {vip && <EndOfRoundButtons {...resetMethods} />}
    </Wrapper>
  );
};
export default VampireWin;
